export default __webpack_public_path__ + "3d1a3d1.png";